<template>
  <div id="regReportUpgradeModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog upgrade-account-modal">
      <div class="modal-content first-modal-content">
        <div class="modal-header upgradeModal-bgcolor">
          <button type="button" class="close" @click="closePopup" data-target="#UpgradeModal">
            &times;
          </button>
          <div class="modal-title">
            <div class="upgrade-service-para fw-400">Upgrade Service</div>
          </div>
        </div>
        <div class="modal-body confirm-body">
          <div class="row m-0">
            <div class="col-sm-6 text-left">Current Service</div>
            <div class="col-sm-6 text-right">Current Price</div>
          </div>
          <div class="row col-xs-12 m-0">
            <hr />
          </div>
          <div class="row m-0">
            <div class="col-xs-6 text-left service-header">
              <p>{{ selectedService.name }}</p>
              <p class="service-description pl-10">
                <span>Renews</span>
                {{ selectedService.valid_until | dateFormat }}
              </p>
            </div>
            <div class="col-xs-6 text-right">
              ${{ selectedService.price }}<span class="service-description"> per year</span>
            </div>
          </div>
          <div class="row col-xs-12 m-0">
            <hr />
          </div>
          <div class="row m-0">
            <div class="col-sm-6 text-left">Upgrade Service</div>
            <div class="col-sm-6 text-right">Additional Price</div>
          </div>
          <div class="row col-xs-12 m-0">
            <hr />
          </div>
          <div class="row m-0">
            <div class="col-xs-10 text-left service-header">
              <ul class="service-description pl-20">
                <li class="pb-10">Includes unlimited reports</li>
                <li class="pb-10">Upgrading will restart the clock and give a pro-rated credit</li>
              </ul>
            </div>
            <div class="col-xs-2 text-right">+$1000</div>
          </div>
        </div>
        <div class="modal-footer cancelModal-bgcolor">
          <div class="col-lg-6 col-sm-6 col-md-6 pl-0 text-left please-cancel-btn">
            <button class="btn btn-block emergo-white-button" @click="closePopup()">Cancel</button>
          </div>
          <div class="col-lg-6 col-sm-6 col-md-6 pr-0 text-right">
            <button class="btn btn-block emergo-green-button" @click="upgradeService()">
              Upgrade Service
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';

export default {
  props: ['selectedService', 'payForUpgradeService'],

  data() {
    return {};
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    },
  },
  methods: {
    closePopup() {
      $('#regReportUpgradeModal').modal('hide');
    },
    async upgradeService() {
      this.$emit('payForUpgradeService', this.selectedService);
      this.closePopup();
    },
  },
  async mounted() {
    const accountTypeId = JSON.parse(localStorage.getItem('userData')).account_type_id;
    this.isREP = accountTypeId === 2 || accountTypeId === 4;
  },
};
</script>

<style lang="scss" scoped>
.service-header {
  font-family: 'Roboto';
  font-style: normal;
  @include fontItems($font-18, 21px, $font-weight-medium);
  padding-left: 30px;
}
.service-description {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: $font-weight-400;
  font-size: 15px;
  line-height: 19px;
}
.modal-header {
  .close {
    background: none;
    opacity: 1;
    height: 17px;
    line-height: 17px;
    color: $deep-gray !important;
    width: 17px;
    border-radius: $radius20;
    font-weight: $font-weight-small;
    outline: none;
    font-size: $font-32;
  }
  &.upgradeModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-top-left-radius: $radius10;
    border-top-right-radius: $radius10;
    padding: 24px;
  }
}
.confirm-body {
  padding: 0 24px;
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  text-align: center;
  font-size: $font-18;
  line-height: 21px;
  color: $dark-black-alpha;
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.modal-footer {
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding: 24px;
  }
}
.upgrade-service-para {
  font-size: $font-24;
  line-height: 28px;
  text-align: left;
  color: $primary;
  font-weight: $font-weight-medium;
}
@media only screen and (max-width: 767px) {
  .please-cancel-btn {
    margin-bottom: 14px;
  }
}
@media only screen and (min-width: 768px) {
  .upgrade-account-modal {
    width: 640px;
  }
}
@media screen and (max-width: 767px) {
  .upgrade-service-para {
    font-size: $font-20;
  }
}
</style>
